import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import MerchantOrders from "../components/merchant/orders";
import MerchantInventory from "../components/merchant/inventory";
import MerchantDelivery from "../components/merchant/delivery";
import MerchantProducts from "../components/merchant/products";
import MerchantQRCode from "../components/merchant/qrcode";
import MerchantReports from "../components/merchant/report";
import Production from "../components/merchant/production";
import Poster from "../components/welcome/Poster";
import MerchantEmployee from "../components/merchant/employee";

const MerchantRoute = () => {
  return (
    <>
      <React.Fragment>
        <Routes>
          <Route hidden path="/" element={<MerchantOrders />} />
          <Route hidden path="/products" element={<MerchantProducts />} />
          <Route hidden path="/inventory" element={<MerchantInventory />} />
          <Route hidden path="/production" element={<Production />} />
          <Route hidden path="/delivery" element={<MerchantDelivery />} />
          <Route hidden path="/qr-code" element={<MerchantQRCode />} />
          <Route hidden path="/report" element={<MerchantReports />} />
          <Route hidden path="/employee" element={<MerchantEmployee />} />
          <Route hidden path="/poster-1" element={<Poster />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Fragment>
    </>
  );
};

export default MerchantRoute;
